<script setup lang="ts">
import { useConfig } from '@/composables/game/config'
import { usePlayer } from '@/composables/game/player'
import { DateTime } from 'luxon'

const { config } = useConfig()
const { player, checkin } = usePlayer()

function isDayDisabled(dayIndex: number) {
  if (!player.value.tasks.dailyCheckin.lastCheckin) {
    return dayIndex !== 0
  }
  const today = DateTime.now().startOf('day')
  const lastCheckinParts = player.value.tasks.dailyCheckin.lastCheckin.split('-')
  const lastCheckin = DateTime.now().startOf('day').set({
    year: Number(lastCheckinParts[0]),
    month: Number(lastCheckinParts[1]),
    day: Number(lastCheckinParts[2]),
  })

  const daysDiff = today.diff(lastCheckin).as('days')
  if (daysDiff <= 0) {
    return true
  }
  if (daysDiff > 1) {
    return dayIndex !== 0
  }

  return player.value.tasks.dailyCheckin.consecutiveDays !== dayIndex
}

function getDayPoints(dayIndex: number) {
  return config.value.game.tasks.dailyCheckin.rewards[dayIndex]
}

function isDayCompleted(dayIndex: number) {
  return player.value.tasks.dailyCheckin.consecutiveDays > dayIndex
}
</script>

<template>
  <div>
    <button
      v-for="dayIndex in [...Array(config.game.tasks.dailyCheckin.rewards.length).keys()]"
      :key="dayIndex"
      :disabled="isDayDisabled(dayIndex)"
      @click="checkin()"
    >
      Check-in day {{ dayIndex + 1 }} {{ isDayCompleted(dayIndex) ? '(Checked in)' : '' }} <br>
      Points: {{ getDayPoints(dayIndex) }}
    </button>
  </div>
</template>

<style scoped>

</style>
